export const CHECK_IN_TOOLTIP =
  'Each month, check in with each stakeholder for 5-10 minutes to get their input on your progress'
